module.exports = __webpack_public_path__ + "static/img/login_left_img.4a107f4b.png";